var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "c-box c-box--alpha" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-box__content" },
          [
            _c(
              "b-container",
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "info" },
                            on: {
                              click: function($event) {
                                return _vm.restartSystem()
                              }
                            }
                          },
                          [_vm._v("Restart system")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm.is_restarting
                  ? _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [_c("loader", [_vm._v("System is restarting")])],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("account-system-restart-ccs-modal")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-box__header" }, [
      _c("div", { staticClass: "c-box__title" }, [
        _vm._v("\n                Account system restart\n            ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }